<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s !important;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0 !important;
  }
  .slide-fade-enter-active, .slide-fade-leave-active{
    transition: all 500ms;
  }
  .slide-fade-enter, .slide-fade-leave-to{
    opacity: 0;
    transform: translateY(20px);
  }
  .font-grey{
    color: rgb(120, 120, 120);
  }
  .text-shadow{
    text-shadow: 1px 1px 1px #2E2E2E;
  }
  .box-shadow{
    box-shadow: 0px 5px 8px 0 rgba(0,0,0,0.4);
  }
  .nav-link:hover{
    color: rgba(255,255,255,.75);
  }
  .sidebar{
    position: fixed;
    height: 100%;
    min-width: 9rem;
    padding: 0 .5rem;
    border-right: solid 1px gainsboro;
    z-index: 2;
  }
  .sidebar li.nav-item{
    margin-top: 1rem;
    text-align: left;
  }
  .view{
    width: 100%;
    padding-left: 9.5rem;
    padding-right: .5rem;
    padding-top: .5rem;
  }
  .box-shadow{
    box-shadow: 0 1px 3px rgba(0,0,0,.2), 0 1px 1px rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12)
  }
  .side-box-shadow{
    box-shadow: 0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12)
  }
  .bg-blue{
    background-color: #1e3e6e !important;
  }
  .bg-orange{
    background-color: #f7941e !important;
  }
  .bg-lightgrey{
    background-color: #9d9d9d !important;
  }
  .bg-midgrey{
    background-color: #9d9d9d !important;
  }
  .bg-darkgrey{
    background-color: #2c2d2f !important;
    color: rgba(255,255,255,.5) !important;
  }
  .bg-red{
    background-color: #d9534f !important;
  }
  .color-orange{
    color: #f7941e !important;
  }
  .color-white{
    color: white !important;
  }
  .color-grey{
    color: rgba(255,255,255,.5) !important;
  }
  .card-header{
    background-color: white;
  }
  .btn-kne-orange{
    background-color: #f7941e !important;
    border-color: #f7941e !important;
    color: white;
  }
  .btn-kne-red{
    background-color: #f7132d !important;
    border-color: #f7132d !important;
    color: white;
  }
  .btn-kne-green{
    background-color: #32f713 !important;
    border-color: #32f713 !important;
    color: white;
  }
  .btn-kne-orange:hover{
    background-color: #e88106 !important;
    border-color: #e88106 !important;
  }
  .card{
    border: 1px solid rgba(0,0,0,.2);
  }
  .bg-darkgrey th{
    background-color: #2c2d2f !important;
    color: rgba(255,255,255,.5) !important;
  }
  .kne-title{
    padding: 1.1rem 2rem;
    background-color: #2c2d2f;
    color: white;
    border-bottom: 3px solid #f7941e;
    margin-bottom: 1rem;
  }
  input[type=date]{
    color: rgb(120, 120, 120);
  }
  body{
    background-color: #f3f3f4;
  }
  th{
    font-weight: normal;
  }
  thead tr{
    border-bottom: 3px solid #f7941e;
  }
  h1, h2 {
    font-weight: normal;
    text-align: center;
  }
  h1{
    font-size: 80px;
  }
  h2{
    font-size: 60px;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
  }
  #current{
    border-left: 3px solid #f7941e;
  }
  #stats{
    display: flex;
    flex-wrap: wrap;
  }
  .badge{
    margin-top: .65rem;
  }
  .table-fix-width{
    max-width: 15rem;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .nowrap{
    white-space: nowrap;
  }
  .paginate-links li.active a {
    font-weight: bold;
  }
  .paginate-links li.next:before {
    content: ' | ';
    margin-right: 13px;
    color: #ddd;
  }
  .paginate-links li.disabled a {
    color: #ccc;
    cursor: no-drop;
  }
  .paginate-links li {
    display: inline-block;
    margin: 0 10px;
  }
  .paginate-links li a{
    cursor: pointer;
    color: #f7941e;
  }
  .paginate-links {
    list-style-type: none;
    padding: 0;
    text-align: center;
  }
  .message {
    border-bottom: 1px solid gainsboro;
    cursor: pointer;
  }
  .header{
    margin: 0;
  }
  .btn-badge{
    margin: 0;
    top: 0 !important;
  }
  .drop {
    background-color: #F5DEB3;
  }
  .cancel {
    background-color: #f2dede;
  }
  .waiting {
    background-color: #c9adff;
  }
  .pick {
    background-color: #B4EEB4;
  }
  .transit {
    background-color: #fcf8e3;
  }
  .dispatch {
    background-color: #d0e3f0;
  }
  .reject {
    background-color: #d46a6a;
    color: white;
  }
  .sortable {
    cursor: pointer;
  }
  th.sortable:hover {
    color: white !important;
  }
</style>



// WEBPACK FOOTER //
// App.vue?141032c5